import React from 'react';
import Supplier from '../components/supplier'

const SupplierPage = (props) => {
	console.log(props);

	const { pathname } = props.location;
	let params = {};

	console.log({pathname});

	if(pathname === "/supplier/add"){
		params.add = true;
	}

	return (
		<Supplier {...params} />
	)
}

export default SupplierPage;


// WEBPACK FOOTER //
// ./src/containers/supplier-page.js